import serialize from 'serialize-javascript';
import jsStringEsc from 'js-string-escape';
export function getAdsSSRConfig(session) {
    var _session_features;
    if (!session.adsEnabled) {
        return {
            shouldIncludeGak: false
        };
    }
    return {
        shouldIncludeGak: true,
        gakContext: toJsonString({
            features: session === null || session === void 0 ? void 0 : (_session_features = session.features) === null || _session_features === void 0 ? void 0 : _session_features.reduce((p, c)=>{
                p[c] = true;
                return p;
            }, {})
        })
    };
}
export function isSSR() {
    return typeof window === 'undefined';
}
function jsStringEscape(json) {
    const result = jsStringEsc(json);
    return `"${result.replace(/<\/(script|style)/gi, '<\\/$1').replace(/<!--/g, '\\u003C!--')}"`;
}
export function toJsonString(jsObject, newrelic = null, newrelicSegmentName = '') {
    if (newrelic) {
        const segment = newrelicSegmentName || 'TO_JSON';
        return newrelic.startSegment(segment, true, ()=>jsStringEscape(serialize(jsObject, {
                isJSON: true
            })));
    }
    return jsStringEscape(serialize(jsObject, {
        isJSON: true
    }));
}
